import { render, staticRenderFns } from "./LabelTag.vue?vue&type=template&id=07b229a2"
import script from "./LabelTag.vue?vue&type=script&lang=ts"
export * from "./LabelTag.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports